import {
  Configuration,
  ConfigToSendInterface,
} from '@greenkub-fronts/shared/interface';

export const formatToMinimalistConfig = (
  configurations: Partial<Configuration>[]
) => {
  const configsToSend: ConfigToSendInterface[] = [];

  configurations.map((config: Partial<Configuration>, index: number) => {
    configsToSend[index] = {
      model: null,
      finish: null,
      equipment: null,
      quantity: 1,
      options: [],
      surface: 0,
      custom_products: [],
      negative_default_option_models: [],
      negative_default_options_finish_equipment: [],
    };

    if (config.chosenStudioList?.studio.model.id) {
      configsToSend[index].model = config.chosenStudioList.studio.model.id;
    }

    if (config.chosenStudioList?.studio.finish.id) {
      configsToSend[index].finish = config.chosenStudioList.studio.finish.id;
    }

    if (config.chosenStudioList?.studio.equipment.id) {
      configsToSend[index].equipment =
        config.chosenStudioList.studio.equipment.id;
    }

    if (config.chosenOptionLists && config.chosenOptionLists.length > 0) {
      config.chosenOptionLists?.forEach((optionList) =>
        configsToSend[index].options.push({
          odooId: optionList.catalogue.odooId,
          quantity: optionList.chosenOption.length,
        })
      );
    }
  });

  return configsToSend;
};
